var api = require("!./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!./node_modules/css-loader/dist/cjs.js!./core.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);

var exported = content.locals ? content.locals : {};



module.exports = exported;